import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

const base =
  'inline-flex min-h-tap items-center justify-center gap-2 rounded px-4 text-body font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50';

const variants: Record<Variant, string> = {
  primary: 'bg-leaf text-cream hover:bg-leaf-soft',
  secondary: 'border border-line bg-paper text-ink hover:bg-cream',
  ghost: 'text-leaf hover:bg-cream',
  danger: 'border border-status-declinedFg/30 text-status-declinedFg hover:bg-status-declinedBg',
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  children: ReactNode;
}

export function Button({
  variant = 'primary',
  loading = false,
  className = '',
  children,
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      {...rest}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={`${base} ${variants[variant]} ${className}`}
    >
      {loading && (
        <span
          aria-hidden="true"
          className="h-3 w-3 animate-spin rounded-pill border border-current border-t-transparent"
        />
      )}
      {children}
    </button>
  );
}
